export default "__VITE_ASSET__ud_lUSKR__"